module.exports = __webpack_public_path__ + "static/media/difficulty_1.8d9f8842.svg";